module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "middle-box text-center animated fadeInDown"
  }, [_c('h1', [_vm._v("404")]), _c('h3', {
    staticClass: "font-bold"
  }, [_vm._v("Page Not Found")]), _c('div', {
    staticClass: "error-desc"
  }, [_vm._v("Sorry, but the page you are looking for has note been found. Try checking the URL for error, then hit the refresh button on your browser or try found something else in our app.")]), _c('br'), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Dashboard'
        })
      }
    }
  }, [_vm._v("Return Home")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-930a7850","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = 429
// module chunks = 3